import { render, staticRenderFns } from "./Lgx240155175900151808.vue?vue&type=template&id=04f94234&scoped=true&"
import script from "./Lgx240155175900151808.vue?vue&type=script&lang=js&"
export * from "./Lgx240155175900151808.vue?vue&type=script&lang=js&"
import style0 from "./Lgx240155175900151808.vue?vue&type=style&index=0&id=04f94234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f94234",
  null
  
)

export default component.exports